var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Validation
import * as yup from 'yup';
// Models
import { ISchemaType, } from '../../models/dataSchema/dataSchemaTypes';
/**
 * Get form validation schema
 * @param required
 * @param properties
 * @param uiSchema
 */
export var getFormValidationSchema = function (_a, uiSchema) {
    var required = _a.required, properties = _a.properties;
    var schema = required.reduce(function (previous, fieldName) {
        var fieldValidation = getFieldValidation(uiSchema, fieldName, properties);
        if (!previous) {
            return fieldValidation;
        }
        return __assign(__assign({}, previous), fieldValidation);
    }, {});
    return yup.object().shape(schema);
};
/**
 * Get field validation
 * @param uiSchema
 * @param fieldName
 * @param properties
 */
var getFieldValidation = function (uiSchema, fieldName, properties) {
    var fieldVisibilityConditions = getFieldConditionVisibility(uiSchema, fieldName);
    var type = properties[fieldName].type;
    return getFieldValidationSchema(fieldName, type, fieldVisibilityConditions, properties[fieldName]);
};
/**
 * Get field condition visibility
 * @param uiSchema
 * @param fieldName
 */
var getFieldConditionVisibility = function (uiSchema, fieldName) {
    var fieldGroup = uiSchema.groups.find(function (group) { return Object.keys(group.properties).includes(fieldName); });
    return fieldGroup && fieldGroup.conditions && fieldGroup.conditions[fieldName]
        ? fieldGroup.conditions[fieldName].visibility
        : undefined;
};
/**
 * Get field schema validation
 * @param fieldName
 * @param type
 * @param fieldVisibilityConditions
 * @param property
 */
var getFieldValidationSchema = function (fieldName, type, fieldVisibilityConditions, property) {
    var _a;
    var validation;
    switch (type) {
        case ISchemaType.Number:
            validation = getFieldDependenciesValidation(yup.number, fieldVisibilityConditions); // yup.number().required(errorRequireText)
            break;
        case ISchemaType.Date:
            validation = getFieldDependenciesValidation(yup.date, fieldVisibilityConditions).max(new Date()); // yup.date().max(new Date()).required(errorRequireText)
            break;
        case ISchemaType.Array:
            validation = getFieldDependenciesValidation(yup.array, fieldVisibilityConditions); // yup.array().required(errorRequireText)
            if (property && property.maxLength) {
                validation = validation.max(property.maxLength);
            }
            if (property && property.minLength) {
                validation = validation.min(property.minLength);
            }
            break;
        default:
            validation = getFieldDependenciesValidation(yup.string, fieldVisibilityConditions); // yup.string().required(errorRequireText)
    }
    return _a = {}, _a[fieldName] = validation, _a;
};
/**
 * Get field dependencies validation
 * @param yupSchema
 * @param fieldVisibilityConditions
 */
var getFieldDependenciesValidation = function (yupSchema, fieldVisibilityConditions) {
    if (!fieldVisibilityConditions) {
        return yupSchema().required();
    }
    if (fieldVisibilityConditions.requiredFieldsValues && fieldVisibilityConditions.requiredFieldsValues.length) {
        return fieldVisibilityConditions.requiredFieldsValues.reduce(function (schema, currentConditions) {
            return buildFieldRequiredValueValidationSchema(yupSchema, schema, currentConditions);
        }, yupSchema());
    }
};
/**
 * Build field validation schema
 * @param schemaConstructor
 * @param currentSchema
 * @param currentConditions
 */
var buildFieldRequiredValueValidationSchema = function (schemaConstructor, currentSchema, currentConditions) {
    var conditionFieldsName = Object.keys(currentConditions);
    return currentSchema.when(conditionFieldsName, {
        is: function () {
            var formFieldUpdateValue = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                formFieldUpdateValue[_i] = arguments[_i];
            }
            return formFieldUpdateValue.reduce(function (previous, value, index) {
                return mergeConditionValidity(previous, value, currentConditions[conditionFieldsName[index]]);
            }, null);
        },
        otherwise: schemaConstructor().notRequired(),
        then: schemaConstructor().required(),
    });
};
/**
 * Merge field condition validity
 * @param previousValidity
 * @param currentValue
 * @param currentConditionValidityValue
 */
var mergeConditionValidity = function (previousValidity, currentValue, currentConditionValidityValue) {
    var isEqual = (currentValue === currentConditionValidityValue);
    if (!previousValidity) {
        return isEqual;
    }
    return Boolean(previousValidity && isEqual);
};
//# sourceMappingURL=form.validity.core.js.map